import { getApplicableTargetLayers } from 'cadenza/api-client/geometry-filtering-api';
import { showGeometryFilteringDialog } from 'cadenza/geometry-filtering-dialog/geometry-filtering-loader';
import { LayerProperty } from 'cadenza/map/layer-property';
import { MapProperty } from 'cadenza/map/map-property';
import { logger } from 'cadenza/utils/logging';
import i18n from 'cadenza/map/layer-actions/layer-actions.properties';

import { LayerAction } from './layer-action';

export class GeometryFiltering extends LayerAction {

  #map;
  #mapId;
  #sourceLayerId;

  constructor (layer, options) {
    super(layer, Object.assign({ label: i18n('geometryFiltering') }, options));
    this.#map = options.map;
    this.#mapId = this.#map.get(MapProperty.ID);
    this.#sourceLayerId = layer.get(LayerProperty.ID);
  }

  execute () {
    showGeometryFilteringDialog(this.#map, this.#sourceLayerId);
  }

  isSupported ({ isEditingLayer }) {
    if (!isEditingLayer && this._layer.get(LayerProperty.HAS_FEATURES) && this._layer.get(LayerProperty.SELECTED_FEATURE_IDS).length > 0) {
      return getApplicableTargetLayers(this.#mapId)
        .then(targetLayers => targetLayers.length)
        .catch(error => logger.error(error));
    }
    return Promise.resolve(false);
  }

  requiresObjectSelection () {
    return true;
  }

}
